import { CorporateWorkgroupValues, workgroupCurrencyType, workgroupUserType } from './types';
export const WORKGROUP_USERS_VALUES: workgroupUserType = {
  id: null,
  _rowTimestamp: null,
  userProfileId: null,
  _isUpdatable: null,
  _isDeletable: null,
  name: null,
  emailAccount: null,
  profileIconState: null,
  profileIconType: null,
  _lastUsedDate: null,
};
export const WORKGROUP_CURRENCY_VALUES: workgroupCurrencyType = {
   id: null,
  _rowTimestamp: null,
  name: null,
  currencyId: null,
  exchangeRate: null,
  spotRate: null,
  isSpotRatePreferred: null,
  _isActive: null,
  _isDeletable: null,
  _isUpdatable: null
};

export const CORPORATE_WORKGROUP_VALUES: CorporateWorkgroupValues = {
  workgroupNumber: null,
  name: null,
  description: null,
  businessUnitId: null,
  chartOfAccountsId: null,
  productionPhaseId: null,
  isNewWorkgroupSelectable: true,
  prefixCode: null,
  productionStatusTypeId: null,
  workgroupUsers: [WORKGROUP_USERS_VALUES],
  workgroupCurrencies: [],
};
